import { render, staticRenderFns } from "./SetupMatchFights.vue?vue&type=template&id=6bef82b5&scoped=true&"
import script from "./SetupMatchFights.vue?vue&type=script&lang=js&"
export * from "./SetupMatchFights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bef82b5",
  null
  
)

export default component.exports